import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import "./common/js/webview";
import './plugins/vant';

Vue.config.productionTip = false;

// Cookie全局化
import Cookie from "js-cookie";
Vue.prototype.$cookie = Cookie;

// moment全局化
import moment from 'moment';
Vue.prototype.$moment = moment;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
